import React from 'react';
import { Form, Input, Select, Switch } from 'antd';
import { PrimaryButton, Modal, H3 } from 'utils';
import { UploadImage } from 'components';
import styled from '@emotion/styled';
import RichTextEditor from './RichTextEditor';

const { Option } = Select;

const ModalContent = styled.div`
  width: 700px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const FormItem = Form.Item;

const PromotionItemModal = ({
  showModal,
  editingItem,
  categories,
  description,
  longDescription,
  itemImage,
  loading,
  form,
  onClose,
  onSubmit,
  onDescriptionChange,
  onLongDescriptionChange,
  onImageChange,
}) => {
  return (
    <Modal showModal={showModal} handelCloseModal={onClose}>
      <ModalContent>
        <H3>{editingItem ? 'Item bearbeiten' : 'Neues Item'}</H3>
        <Form form={form} layout="vertical" onFinish={onSubmit}>
          <FormItem
            label="Titel"
            name="title"
            rules={[
              { required: true, message: 'Bitte geben Sie einen Titel ein' },
            ]}
          >
            <Input placeholder="Item Titel" />
          </FormItem>

          <FormItem label="Untertitel (Preis)" name="subtitle">
            <Input placeholder="z.B. 100,00 €" />
          </FormItem>

          <FormItem
            label="Kategorie"
            name="promotion_category_id"
            rules={[
              {
                required: true,
                message: 'Bitte wählen Sie eine Kategorie aus',
              },
            ]}
          >
            <Select
              style={{ zIndex: 999 }}
              placeholder="Kategorie auswählen"
              showSearch={true}
              optionFilterProp="children"
            >
              {categories.map((cat) => (
                <Option key={cat.id} value={cat.id}>
                  {cat.name}
                </Option>
              ))}
            </Select>
          </FormItem>

          <FormItem label="Green" name="green_flag" valuePropName="checked">
            <Switch
              checkedChildren="Ja"
              unCheckedChildren="Nein"
              size="default"
            />
          </FormItem>

          <FormItem
            label="Is Suggested"
            name="is_suggested"
            valuePropName="checked"
          >
            <Switch
              checkedChildren="Ja"
              unCheckedChildren="Nein"
              size="default"
            />
          </FormItem>

          <div style={{ marginBottom: 16 }}>
            <label
              style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}
            >
              Beschreibung
            </label>
            <RichTextEditor
              value={description}
              onChange={onDescriptionChange}
              placeholder="Beschreibung eingeben..."
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label
              style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}
            >
              Ausführliche Beschreibung
            </label>
            <RichTextEditor
              value={longDescription}
              onChange={onLongDescriptionChange}
              placeholder="Ausführliche Beschreibung eingeben..."
            />
          </div>

          <UploadImage
            multiple={false}
            label={<p>Bild</p>}
            name="itemImage"
            setImage={onImageChange}
            fileList={
              editingItem && editingItem.image_url
                ? [editingItem.image_url]
                : []
            }
          />

          <PrimaryButton
            type="primary"
            htmlType="submit"
            loading={loading}
            minWidth="100px"
          >
            {editingItem ? 'Aktualisieren' : 'Hinzufügen'}
          </PrimaryButton>
        </Form>
      </ModalContent>
    </Modal>
  );
};

export default PromotionItemModal;
